import { render, staticRenderFns } from "./OrderOverview.vue?vue&type=template&id=7b0c19b2&scoped=true"
import script from "./OrderOverview.vue?vue&type=script&lang=js"
export * from "./OrderOverview.vue?vue&type=script&lang=js"
import style0 from "./OrderOverview.vue?vue&type=style&index=0&id=7b0c19b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0c19b2",
  null
  
)

export default component.exports